module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_c/aoj_c-3-fa670172b834cb45f10aadb14d31f3ad.jpg";